import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

if (!SOCKET_URL) {
  console.error('SOCKET_URL is not defined. Make sure environment variables are properly configured.');
}

console.log('Socket URL:', SOCKET_URL); // Log the socket URL being used

class SocketService {
    constructor() {
        this.socket = null;
        this.messageHandlers = new Set();
    }

    connect() {
        if (!this.socket) {
            console.log('Attempting to connect to WebSocket...', SOCKET_URL); // Log connection attempt with URL
            this.socket = io(SOCKET_URL, {
                transports: ['polling', 'websocket'], // Start with polling, upgrade to websocket
                reconnection: true,
                reconnectionAttempts: 10,
                reconnectionDelay: 1000,
                reconnectionDelayMax: 5000,
                timeout: 20000,
                autoConnect: true,
                forceNew: true,
                path: '/socket.io/',
                withCredentials: false,
                extraHeaders: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            
            // Connection event handlers
            this.socket.on('connect', () => {
                console.log('WebSocket connected successfully', this.socket.id);
            });

            this.socket.on('connect_error', (error) => {
                console.error('WebSocket connection error:', error.message);
                console.log('Current transport:', this.socket.io.engine.transport.name);
                console.log('Available transports:', this.socket.io.engine.transports);
            });

            this.socket.on('error', (error) => {
                console.error('Socket error:', error);
            });

            this.socket.on('disconnect', (reason) => {
                console.log('WebSocket disconnected:', reason);
                if (reason === 'io server disconnect') {
                    // Reconnect if server disconnected
                    this.socket.connect();
                }
            });
            
            // Set up message handler
            this.socket.on('new_message', (message) => {
                console.log('Received new message:', message); // Log incoming messages
                this.messageHandlers.forEach(handler => handler(message));
            });
        }
    }

    disconnect() {
        if (this.socket) {
            console.log('Disconnecting WebSocket...'); // Log disconnection
            this.socket.disconnect();
            this.socket = null;
        }
    }

    onMessage(handler) {
        console.log('Adding message handler'); // Log when handlers are added
        this.messageHandlers.add(handler);
        return () => {
            console.log('Removing message handler'); // Log when handlers are removed
            this.messageHandlers.delete(handler);
        };
    }
}

export const socketService = new SocketService(); 